import React from 'react';
import Modal from '../../../../../components/Modal';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import BaseForm from '../../../../../components/form/BaseForm';
import Select from '../../../../../components/input/Select/Select';
import Input from '../../../../../components/input/Input/Input';
import SearchBox from '../../../../../components/outline/SearchBox';
import Table from '../../../../../components/_table/Table/Table';
import { WIDGET_SEARCH_KEYWORD } from '../../../../../store/modules/widget/models';
import { WIDGET_SEARCH_KEYWORD_TYPE_SELECT_LIST } from '../../../../../constants/service/app/widgetConstants';
import { columns } from './columns';

const SearchInactiveWidgetModal = (props) => {
  const {
    isOpen,
    closeModal,
    onChangeKeyword,
    setData,
    getList,
    searchData,
    selectedWidgetIdList,
    data,
    getWidgetPreviewData,
    onSubmit,
  } = props;
  const { list, pagination } = data;
  const { searchKeyword } = searchData;

  return (
    <Modal
      title="비활성 위젯 리스트 검색하기"
      isOpen={isOpen}
      width={800}
      height={600}
      isFooter={true}
      okText="노출중인 위젯으로 추가하기"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="search-inactive-widget-modal-wrap">
        <SearchBox
          className="widget-all-list-search-box"
          onSearch={() => {
            getList({
              searchOption: searchData,
              pagination: _LIST_PAGINATION_MODEL,
            });
          }}
          onClear={() => {
            getList({
              searchOption: {
                searchKeyword: WIDGET_SEARCH_KEYWORD,
              },
              pagination: _LIST_PAGINATION_MODEL,
            });
            setData({
              name: 'searchData',
              value: {
                searchKeyword: WIDGET_SEARCH_KEYWORD,
              },
            });
          }}
        >
          {/*위젯 키워드 검색*/}
          <BaseForm
            label={
              <Select
                className="widget-keyword-search-type-select"
                list={WIDGET_SEARCH_KEYWORD_TYPE_SELECT_LIST}
                onChange={(value) =>
                  onChangeKeyword({
                    type: value,
                    text: searchKeyword.text,
                  })
                }
                defaultValue={searchKeyword.type}
                value={searchKeyword.type}
                isTable={true}
              />
            }
            content={
              <Input
                value={searchKeyword.text}
                onChange={(value) =>
                  onChangeKeyword({
                    type: searchKeyword.type,
                    text: value,
                  })
                }
                maxLength={30}
                size="large"
                onPressEnter={() =>
                  getList({
                    searchOption: searchData,
                    pagination: _LIST_PAGINATION_MODEL,
                  })
                }
              />
            }
          />
        </SearchBox>

        <Table
          columns={(utils) =>
            columns({
              setData,
              getWidgetPreviewData,
              ...utils,
            })
          }
          rowKey={(record) => record.id}
          pagination={pagination}
          list={list}
          size="small"
          scroll={{ x: true }}
          bordered={true}
          getList={getList}
          onCheck={(list) =>
            setData({
              name: 'selectedWidgetIdList',
              value: list,
            })
          }
          selectedList={selectedWidgetIdList}
        />
      </div>
    </Modal>
  );
};

export default SearchInactiveWidgetModal;
